<template>
  <div id="Renew">
		<b-container fluid>
			<b-row>
				<b-col lg="6" md="12" class="player">
          <img src="@/assets/images/player-4.png" alt="Player" />
        </b-col>
				<b-col lg="6" md="12" class="renewList">
					<h1>How to Renew</h1>
          <div class="line"></div>
					<!-- <p>Thank you for being a Rays Season Member! Renew your seats now for the 2019 and 2020 seasons via the Double Play opportunity and receive the lowest season ticket price, added benefits and the choice of one exclusive gift. Also, spread out your payments interest-free via the 20-month Autopay option. If you have a Half Season or 22 Game Plan, upgrade today to the Full Season Plan and receive access to the best Double Play gift options.</p> -->
					<p v-if="credit != ' $ -   '">As of February 15, 2021, you have <span>{{credit}} in ticket credit</span> plus a 25% bonus in the amount of {{bonus}} for concessions and merchandise.</p>
					<p>To renew your Season Membership for the 2021 season, choose one of the options below.</p>
					<div class="renewWrap">
						<div class="number">
							01
						</div>
						<div class="renewItem">
							<img svg-inline :src="require('@/assets/icons/renew-1.svg')" />
							<h2>Online (Most Convenient)</h2>
							<h3>Pay with a credit card</h3>
							<p>Click the 'Renew Now' button below. You will then be prompted to log in to your online Rays Ticket Account and select your Membership Level. If you have ticket credit, it will automatically be applied before completing your purchase. After finalizing your payment, you'll receive a confirmation email with the details of your purchase.</p>
							<div class="renewBtn">
								<b-button v-b-modal.modal-2>Renew Now</b-button>
							</div>
						</div>
					</div>
					<div class="renewWrap">
						<div class="number">
							02
						</div>
						<div class="renewItem">
							<img svg-inline :src="require('@/assets/icons/renew-2.svg')" />
							<h2>Invoice</h2>
							<h3>Pay with a check</h3>
							<p>Select your Season Membership Level, payment option, sign and date, then mail to:<br />
								Tampa Bay Rays<br />
								P.O. Box 15758<br />
								St. Petersburg, FL 33733</p>
							<div class="invoiceBtn">
								<b-button v-b-modal.modal-3>View Invoice</b-button>
							</div>
						</div>
					</div>
					<p class="smallPrint">Please note, all seat locations, game availability and access to benefits are subject to change. Seating capacity may  be restricted and/or vary throughout the 2021 season.</p>
				</b-col>
			</b-row>
		</b-container>
		<b-modal id="modal-2" ref="my-modal" size="lg" title="Important Information" hide-footer>
			<p>If the credit on your account is greater than your Membership Level, you may use this additional credit to purchase game tickets at any time during the 2021 season. You may also choose to upgrade to the next Membership Level.</p> 
			
			<div class="renewBtn">
				<a href="https://mpv.tickets.com/?orgid=48469&agency=MLB_MPV&pid=8886502#/auth/login?ret=event/8886502&promoId=1516" target="_blank">Proceed</a>
			</div>
			
			<p><a v-scroll-to="'#Faq'" @click="hideModal">Questions? Visit our FAQ</a></p>
    </b-modal>

		<b-modal id="modal-3" ref="my-modal" size="lg" title="Select your Membership Level" hide-footer>
			<div class="invoiceOptions">
				<div class="option">
					<label for="500">$500</label>
					<input type="radio" id="500" value="500" name="invoiceOption" v-model="membershipLevel">
				</div>

				<div class="option">
					<label for="2000">$2,000</label>
					<input type="radio" id="2000" value="2000" name="invoiceOption" v-model="membershipLevel">
				</div>

				<div class="option">
					<label for="4000">$4,000</label>
					<input type="radio" id="4000" value="4000" name="invoiceOption" v-model="membershipLevel">
				</div>

				<div class="option">
					<label for="8000">$8,000</label>
					<input type="radio" id="8000" value="8000" name="invoiceOption" v-model="membershipLevel">
				</div>

				<div class="option">
					<label for="12000">$12,000</label>
					<input type="radio" id="12000" value="12000" name="invoiceOption" v-model="membershipLevel">
				</div>

				<div class="option">
					<label for="20000">$20,000</label>
					<input type="radio" id="20000" value="20000" name="invoiceOption" v-model="membershipLevel">
				</div>
			</div>
			
			<div class="renewBtn">
				<b-button @click="hideModaltoInvoice">View Invoice</b-button>
				<div id="selectInvoiceErr">Please select a Membership Level</div>
			</div>

			<p><a v-scroll-to="'#Faq'" @click="hideModal">Questions? Visit our FAQ</a></p>
    </b-modal>

		<b-modal id="modal-invoice-20000" ref="my-modal-invoice-20000" size="xl" hide-header hide-footer>
			<Invoice20000 />
    </b-modal>

		<b-modal id="modal-invoice-12000" ref="my-modal-invoice-12000" size="xl" hide-header hide-footer>
			<Invoice12000 />
    </b-modal>

		<b-modal id="modal-invoice-8000" ref="my-modal-invoice-8000" size="xl" hide-header hide-footer>
			<Invoice8000 />
    </b-modal>

		<b-modal id="modal-invoice-4000" ref="my-modal-invoice-4000" size="xl" hide-header hide-footer>
			<Invoice4000 />
    </b-modal>

		<b-modal id="modal-invoice-2000" ref="my-modal-invoice-2000" size="xl" hide-header hide-footer>
			<Invoice2000 />
    </b-modal>

		<b-modal id="modal-invoice-500" ref="my-modal-invoice-500" size="xl" hide-header hide-footer>
			<Invoice500 />
    </b-modal>
  </div>
</template>

<script>
import Invoice20000 from "@/components/sections/Invoice/Invoice20000";
import Invoice12000 from "@/components/sections/Invoice/Invoice12000";
import Invoice8000 from "@/components/sections/Invoice/Invoice8000";
import Invoice4000 from "@/components/sections/Invoice/Invoice4000";
import Invoice2000 from "@/components/sections/Invoice/Invoice2000";
import Invoice500 from "@/components/sections/Invoice/Invoice500";
export default {
	name: "Renew",
	components: {
		Invoice20000,
		Invoice12000,
		Invoice8000,
		Invoice4000,
		Invoice2000,
		Invoice500
	},
	data() {
    return {
			membershipLevel: "",
			credit: null,
			bonus: null
		}
	},
	methods: {
		hideModal() {
			this.$refs['my-modal'].hide()
		},
		hideModaltoInvoice() {
			if (this.membershipLevel === "") {
				document.getElementById("selectInvoiceErr").style.display = "block";
			}
			if (this.membershipLevel === "20000") {
				this.$refs['my-modal'].hide()
				this.$refs['my-modal-invoice-20000'].show()
			}	
			if (this.membershipLevel === "12000") {
				this.$refs['my-modal'].hide()
				this.$refs['my-modal-invoice-12000'].show()
			}
			if (this.membershipLevel === "8000") {
				this.$refs['my-modal'].hide()
				this.$refs['my-modal-invoice-8000'].show()
			}	
			if (this.membershipLevel === "4000") {
				this.$refs['my-modal'].hide()
				this.$refs['my-modal-invoice-4000'].show()
			}	
			if (this.membershipLevel === "2000") {
				this.$refs['my-modal'].hide()
				this.$refs['my-modal-invoice-2000'].show()
			}
			if (this.membershipLevel === "500") {
				this.$refs['my-modal'].hide()
				this.$refs['my-modal-invoice-500'].show()
			}		
		}
	},
	created(){
    let userInfo = this.$store.state.global.userInfo;
		this.credit = userInfo.totalCredit
		this.bonus = userInfo.totalBonus
  }
}
</script>

<style lang="scss" scoped>
	#Renew {	
		.renewList {
			padding-right: 7%;
      h1 {
        font-family: 'UniversLTStd-UltraCn';
        color: $dark-blue;
        font-size: 50px;
        text-transform: uppercase;
				@media only screen and (max-width: $sm) {
					font-size: 42px;
				}
      }
      .line{
        background-color: $yellow;
        width: 190px;
        height: 3px;
        margin: 10px 0;
      }
      p {
        font-family: 'UniversLTStd';
        font-size: 16px;
        color: #000;
        margin: 40px 0 10px 0;
				text-align: justify;
				text-justify: inter-word;
        &.smallPrint {
          font-family: 'UniversLTStd-Obl';
          font-size: 12px;
          margin: 10px 0;
        }
				span {
					font-family: 'UniversLTStd-Bold';
				}
      }
			.renewWrap {
				display: flex;
				margin: 30px 0;
				.number {
					font-family: 'UniversLTStd-UltraCn';
					color: $dark-blue;
					font-size: 120px;
					font-weight: bold;
					margin-right: 10px;
					line-height: 140px;
					@media only screen and (max-width: $sm) {
						font-size: 55px;
						position: relative;
						bottom: 18px;
					}
				}
				.renewItem {
					margin: 20px 0;
					img {
						width: 60px;
						background-color: $yellow;
						border-radius: 50%;
						padding: 7px;
					}
					h2 {
						font-family: 'UniversLTStd-Bold';
						font-size: 36px;
						color: $dark-blue;
						@media only screen and (max-width: $sm) {
							font-size: 26px;
						}
					}
					h3 {
						font-family: 'UniversLTStd-Bold';
						font-size: 20px;
						color: $dark-blue;
						margin-bottom: 5px;
					}
					p {
						margin: 0;
					}
					.renewBtn {
						margin-top: 30px;
						a {
							font-family: 'UniversLTStd-Bold';
							font-size: 16px;
							color: #000;
							background-color: $yellow;
							border-radius: 25px;
							padding: 15px 40px;
							text-transform: uppercase;
							&:hover {
								text-decoration: none;
							}
						}
						button {
							font-family: 'UniversLTStd-Bold';
							font-size: 16px;
							color: #000;
							background-color: $yellow !important;
							border-radius: 25px;
							padding: 13px 40px;
							text-transform: uppercase;
							width: 200px;
							&:hover {
								text-decoration: none;
							}
						}
					}
					.invoiceBtn {
						margin-top: 30px;
						a {
							font-family: 'UniversLTStd-Bold';
							font-size: 16px;
							color: #000;
							background-color: $light-blue;
							border-radius: 25px;
							padding: 15px 40px;
							text-transform: uppercase;
							&:hover {
								text-decoration: none;
							}
						}
						button {
							font-family: 'UniversLTStd-Bold';
							font-size: 16px;
							color: #000;
							background-color: $light-blue !important;
							border-radius: 25px;
							padding: 13px 40px;
							text-transform: uppercase;
							width: 200px;
							&:hover {
								text-decoration: none;
							}
						}
					}
				}
			}
		}
		.player {
			padding: 0 0 0 3%;
			margin: 0;
			img {
				width: 100%;
			}
		}
	}
</style>